"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var type_1 = require("../types/type");
var value_1 = require("../evaluator/value");
var util_1 = require("../evaluator/util");
function registerBitwiseFunctions(context) {
    context.registerFunction('bitand', {
        invokeWithASTParameters: false,
        signature: {
            type: "fixed",
            parameters: [type_1.NumberType, type_1.NumberType],
            returns: type_1.NumberType,
        },
        invoke: function (_a) {
            var a = _a[0], b = _a[1];
            return value_1.Value.number(util_1.coerceNumber(a) & util_1.coerceNumber(b));
        },
    });
    context.registerFunction('bitor', {
        invokeWithASTParameters: false,
        signature: {
            type: "fixed",
            parameters: [type_1.NumberType, type_1.NumberType],
            returns: type_1.NumberType,
        },
        invoke: function (_a) {
            var a = _a[0], b = _a[1];
            return value_1.Value.number(util_1.coerceNumber(a) | util_1.coerceNumber(b));
        },
    });
    context.registerFunction('bitxor', {
        invokeWithASTParameters: false,
        signature: {
            type: "fixed",
            parameters: [type_1.NumberType, type_1.NumberType],
            returns: type_1.NumberType,
        },
        invoke: function (_a) {
            var a = _a[0], b = _a[1];
            return value_1.Value.number(util_1.coerceNumber(a) ^ util_1.coerceNumber(b));
        },
    });
    context.registerFunction('bitlshift', {
        invokeWithASTParameters: false,
        signature: {
            type: "fixed",
            parameters: [type_1.NumberType, type_1.NumberType],
            returns: type_1.NumberType,
        },
        invoke: function (_a) {
            var a = _a[0], b = _a[1];
            return value_1.Value.number(util_1.coerceNumber(a) << util_1.coerceNumber(b));
        },
    });
    context.registerFunction('bitrshift', {
        invokeWithASTParameters: false,
        signature: {
            type: "fixed",
            parameters: [type_1.NumberType, type_1.NumberType],
            returns: type_1.NumberType,
        },
        invoke: function (_a) {
            var a = _a[0], b = _a[1];
            return value_1.Value.number(util_1.coerceNumber(a) >> util_1.coerceNumber(b));
        },
    });
}
exports.default = registerBitwiseFunctions;
//# sourceMappingURL=bitwise.js.map